import { render } from "./MarketingHubMenu.vue?vue&type=template&id=81311cf6&scoped=true"
import script from "./MarketingHubMenu.vue?vue&type=script&lang=js"
export * from "./MarketingHubMenu.vue?vue&type=script&lang=js"

import "./MarketingHubMenu.vue?vue&type=style&index=0&id=81311cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81311cf6"]])

export default __exports__